export const REGIONS = {
    BRAZIL: 'br',
    NORTH_AMERICA: 'na'
}
